module.exports = __webpack_public_path__ + "static/media/default-user.dc6cdc7f.jpg";